import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface GetShipmentCategoryTypeRequestParams {
  CustomerKey: string;
}

const getShipmentCategoryTypeAPI = (params: GetShipmentCategoryTypeRequestParams) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentCategoryType`,
    method: 'get',
    params,
  });
};

export type ShipmentCategoryTypeResponse = {
  hierLookupDetName: null;
  hierLookupName: string;
  hierLookupDetKey: number;
}[];

export const fetchShipmentCategoryType = async (
  params: GetShipmentCategoryTypeRequestParams,
): Promise<ShipmentCategoryTypeResponse> => {
  const response: AxiosResponse<ShipmentCategoryTypeResponse> = await getShipmentCategoryTypeAPI(params);
  return response.data;
};
